import {
  convertDateByTimezone,
  formatToDate,
  formatToDateTimeShort,
} from 'helpers';
import { Typography } from 'libs/ui';

import { OrdersListItem } from '../../../types';

export const renderDate = (
  item: OrdersListItem,
  field: keyof OrdersListItem,
  brokerTimezoneOffset: number
) => {
  const date = item[field];

  if (date instanceof Date) {
    const brokerDate = convertDateByTimezone(date, brokerTimezoneOffset);
    return (
      <Typography title={formatToDate(brokerDate)}>
        {formatToDate(brokerDate)}
      </Typography>
    );
  }
  return null;
};

export const renderDateTime = (
  item: OrdersListItem,
  field: keyof OrdersListItem,
  brokerTimezoneOffset: number
) => {
  const date = item[field];

  if (date instanceof Date) {
    const brokerDate = convertDateByTimezone(date, brokerTimezoneOffset);
    return (
      <Typography title={formatToDateTimeShort(brokerDate)}>
        {formatToDateTimeShort(brokerDate)}
      </Typography>
    );
  }
  return null;
};
